/**
 * PONTO DE ENTRADA PRINCIPAL — STELLARI SERVE
 * Implantação Super Lazinho Avenida 7
 */

import './styles/main.css';
import { STORE_INFO } from './data/menuData.js';
import { store } from './state/store.js';
import { formatCurrency } from './utils/formatters.js';

// Visualizações
import { renderHomeView } from './views/homeView.js';
import { renderCategoryView } from './views/categoryView.js';
import { renderProductView } from './views/productView.js';
import { renderJantinhaView } from './views/jantinhaView.js';
import { renderCartView } from './views/cartView.js';
import { renderCheckoutView } from './views/checkoutView.js';

const appEl = document.querySelector('#app');

function renderApp() {
  if (!appEl) return;

  const itemCount = store.getItemCount();
  const subtotal = store.getSubtotal();
  const currentView = store.currentView;

  appEl.innerHTML = `
    <!-- Cabeçalho Fixo Superior Limpo e Destacado -->
    <header class="site-header">
      <div class="header-inner">
        <!-- Logo e Retorno sem redundância na Home -->
        <div class="header-brand" id="nav-brand-btn" role="button" tabindex="0" aria-label="Voltar para a página inicial">
          <img src="${STORE_INFO.logo}" alt="${STORE_INFO.name}" class="header-logo" />
          ${currentView !== 'home' ? `
            <div class="header-brand-info">
              <span class="header-title">${STORE_INFO.name}</span>
            </div>
          ` : ''}
        </div>

        <!-- Botão do Carrinho Aumentado e com Alta Visibilidade -->
        <div class="header-actions">
          <button id="nav-cart-btn" class="header-cart-btn ${itemCount > 0 ? 'has-items' : ''}" aria-label="Abrir Carrinho de Compras (${itemCount} itens)">
            <svg class="icon-cart" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
            <span class="header-cart-text">Carrinho</span>
            ${itemCount > 0 ? `
              <span class="header-cart-count" aria-label="${itemCount} itens no carrinho">${itemCount}</span>
              <span class="header-cart-total-badge">${formatCurrency(subtotal)}</span>
            ` : ''}
          </button>
        </div>
      </div>
    </header>

    <!-- Conteúdo Principal da Tela Ativa -->
    <main class="app-container" id="main-view-container"></main>

    <!-- Barra Flutuante do Carrinho (Visível em páginas de catálogo quando houver itens) -->
    ${itemCount > 0 && currentView !== 'cart' && currentView !== 'checkout' ? `
      <aside class="cart-floating-bar" id="floating-cart-bar" role="region" aria-label="Resumo do carrinho">
        <div class="cart-bar-info">
          <div class="cart-bar-badge">${itemCount}</div>
          <div class="cart-bar-text">
            <span class="cart-bar-label">Seu Carrinho</span>
            <span class="cart-bar-total">${formatCurrency(subtotal)}</span>
          </div>
        </div>
        <button id="btn-view-floating-cart" class="btn btn-sm btn-primary" type="button">
          Ver Carrinho →
        </button>
      </aside>
    ` : ''}

    <!-- Rodapé Institucional Homologado -->
    <footer class="site-footer">
      <div class="footer-inner">
        <div class="footer-establishment-info">
          <strong class="footer-store-name">${STORE_INFO.name}</strong>
          <p class="footer-address">${STORE_INFO.address}</p>
          <div class="footer-whatsapp-note">
            <span class="badge badge-pending">Canal WhatsApp para teste técnico: ${STORE_INFO.whatsappDisplay}</span>
          </div>
        </div>

        <div class="stellari-signature">
          <p class="stellari-copyright">© 2026 STELLARI PRODUÇÕES — Soluções Digitais. Todos os direitos reservados.</p>
          <p class="stellari-tech">Tecnologia STELLARI SERVE</p>
        </div>
      </div>
    </footer>
  `;

  // Listeners Globais do Header e Barra Flutuante
  const brandBtn = appEl.querySelector('#nav-brand-btn');
  const handleHomeNav = () => store.setView('home');
  brandBtn?.addEventListener('click', handleHomeNav);
  brandBtn?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleHomeNav();
    }
  });

  appEl.querySelector('#nav-cart-btn')?.addEventListener('click', () => {
    store.setView('cart');
  });

  appEl.querySelector('#floating-cart-bar')?.addEventListener('click', () => {
    store.setView('cart');
  });

  // Renderiza a view correspondente
  const viewContainer = appEl.querySelector('#main-view-container');
  if (!viewContainer) return;

  switch (currentView) {
    case 'home':
      renderHomeView(viewContainer, store);
      break;
    case 'category':
      renderCategoryView(viewContainer, store);
      break;
    case 'product':
      renderProductView(viewContainer, store);
      break;
    case 'jantinha':
      renderJantinhaView(viewContainer, store);
      break;
    case 'cart':
      renderCartView(viewContainer, store);
      break;
    case 'checkout':
      renderCheckoutView(viewContainer, store);
      break;
    default:
      renderHomeView(viewContainer, store);
  }

  // Rola suavemente ao topo ao trocar de view
  window.scrollTo({ top: 0, behavior: 'instant' });
}

// Inscrição reativa para re-renderizar quando o estado mudar
store.subscribe(() => {
  renderApp();
});

// Render inicial
renderApp();
